module.exports = __webpack_public_path__ + "static/media/specialty-retirement-living.cc6cf421.svg";